export default "__VITE_ASSET__WSAV6itk__"